import React from "react";
import { FavoriteBorderOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getReadTime } from "../../utilities/commonUtils";
import OptimizedImage from "../common/OptimizedImage";
import { trackEvent } from "../../analytics/analyticsClient";

const getInitials = (name = "AA") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "AA";

const formatDate = (date) => {
  if (!date) return "";
  return new Date(date).toDateString();
};

const getTagClass = (category = "") => {
  const normalized = category.toLowerCase();

  if (normalized.includes("artificial intelligence") || normalized === "ai") {
    return "home-tag ai";
  }

  if (normalized.includes("ui") || normalized.includes("ux")) {
    return "home-tag ux";
  }

  return "home-tag";
};

const Blog = ({ blogDetails, view = "list" }) => {
  const navigate = useNavigate();
  const {
    category,
    date,
    description,
    title,
    username,
    userrole,
    _id,
    blogImage,
    likes = [],
  } = blogDetails;

  const isGridView = view === "grid";

  return (
    <div
      className={`home-blog-card ${isGridView ? "home-blog-card-grid" : ""}`}
      onClick={() => {
        trackEvent("blog_card_clicked", {
          blogId: _id,
          blogTitle: title,
          category,
          position: isGridView ? "grid" : "list",
        });
        navigate(`/blogs/${_id}`);
      }}
    >
      <div className="home-card-image-wrap">
        <OptimizedImage
          className="home-card-image"
          src={blogImage}
          alt={title || "blog-thumbnail"}
          width={320}
          height={200}
          widths={isGridView ? [240, 320, 480] : [240, 320, 400]}
          sizes={
            isGridView
              ? "(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 33vw"
              : "(max-width: 767px) 100vw, 320px"
          }
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className={`home-card-body ${isGridView ? "home-card-body-grid" : ""}`}>
        <div className="home-card-meta-row">
          <div className="home-card-author-chip">
            <div className="home-card-dot">{getInitials(username)}</div>
            <span className="home-card-author">{username || "Anonymous"}</span>
          </div>
          <span className="home-card-role home-card-sep">
            · {userrole || category || "Contributor"} ·
          </span>
          <span className="home-card-date">{formatDate(date)}</span>
        </div>

        <h3 className="home-blog-title">{title}</h3>
        <p
          className={`home-blog-excerpt ${
            isGridView ? "home-blog-excerpt-grid" : ""
          }`}
        >
          {description || "Read the full story on AAPMOR Blogs."}
        </p>

        <div className={`home-card-footer ${isGridView ? "home-card-footer-grid" : ""}`}>
          <span className={getTagClass(category)}>{category || "Blog"}</span>
          <span className="home-read-time">{getReadTime(blogDetails)}</span>
          <button className="home-like-btn" type="button">
            <FavoriteBorderOutlined sx={{ fontSize: 15 }} />
            {likes.length}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Blog;
